// extracted by mini-css-extract-plugin
module.exports = {"skeletonBox":"SkeletonImage_skeletonBox__KY095","shimmer":"SkeletonImage_shimmer__iuhzQ"};